import React from "react";
import styled from "styled-components";

export default styled.div`
    float: left;         
    text-align: right;
    font-size: 20px;
    position: absolute;
    bottom: 52px;
    left: 52px;
    right: 52px;
`;